function singleValueData(plotRow) {
    return {
        value: plotRow._internal_value[3 /* PlotRowValueIndex.Close */],
        time: plotRow._internal_originalTime,
    };
}
function lineData(plotRow) {
    const result = singleValueData(plotRow);
    if (plotRow._internal_color !== undefined) {
        result.color = plotRow._internal_color;
    }
    return result;
}
function areaData(plotRow) {
    const result = singleValueData(plotRow);
    if (plotRow._internal_lineColor !== undefined) {
        result.lineColor = plotRow._internal_lineColor;
    }
    if (plotRow._internal_topColor !== undefined) {
        result.topColor = plotRow._internal_topColor;
    }
    if (plotRow._internal_bottomColor !== undefined) {
        result.bottomColor = plotRow._internal_bottomColor;
    }
    return result;
}
function baselineData(plotRow) {
    const result = singleValueData(plotRow);
    if (plotRow._internal_topLineColor !== undefined) {
        result.topLineColor = plotRow._internal_topLineColor;
    }
    if (plotRow._internal_bottomLineColor !== undefined) {
        result.bottomLineColor = plotRow._internal_bottomLineColor;
    }
    if (plotRow._internal_topFillColor1 !== undefined) {
        result.topFillColor1 = plotRow._internal_topFillColor1;
    }
    if (plotRow._internal_topFillColor2 !== undefined) {
        result.topFillColor2 = plotRow._internal_topFillColor2;
    }
    if (plotRow._internal_bottomFillColor1 !== undefined) {
        result.bottomFillColor1 = plotRow._internal_bottomFillColor1;
    }
    if (plotRow._internal_bottomFillColor2 !== undefined) {
        result.bottomFillColor2 = plotRow._internal_bottomFillColor2;
    }
    return result;
}
function ohlcData(plotRow) {
    return {
        open: plotRow._internal_value[0 /* PlotRowValueIndex.Open */],
        high: plotRow._internal_value[1 /* PlotRowValueIndex.High */],
        low: plotRow._internal_value[2 /* PlotRowValueIndex.Low */],
        close: plotRow._internal_value[3 /* PlotRowValueIndex.Close */],
        time: plotRow._internal_originalTime,
    };
}
function barData(plotRow) {
    const result = ohlcData(plotRow);
    if (plotRow._internal_color !== undefined) {
        result.color = plotRow._internal_color;
    }
    return result;
}
function candlestickData(plotRow) {
    const result = ohlcData(plotRow);
    const { _internal_color: color, _internal_borderColor: borderColor, _internal_wickColor: wickColor } = plotRow;
    if (color !== undefined) {
        result.color = color;
    }
    if (borderColor !== undefined) {
        result.borderColor = borderColor;
    }
    if (wickColor !== undefined) {
        result.wickColor = wickColor;
    }
    return result;
}
function clusterData(plotRow) {
    const result = ohlcData(plotRow);
    const { _internal_color: color, _internal_borderColor: borderColor, _internal_wickColor: wickColor, _internal_trades: trades } = plotRow;
    const data = Object.assign(Object.assign({}, result), { trades });
    if (color !== undefined) {
        data.color = color;
    }
    if (borderColor !== undefined) {
        data.borderColor = borderColor;
    }
    if (wickColor !== undefined) {
        data.wickColor = wickColor;
    }
    return data;
}
const seriesPlotRowToDataMap = {
    Area: areaData,
    Line: lineData,
    Baseline: baselineData,
    Histogram: lineData,
    Bar: barData,
    Candlestick: candlestickData,
    Cluster: clusterData,
};
export function getSeriesDataCreator(seriesType) {
    return seriesPlotRowToDataMap[seriesType];
}
